// File: frontend/src/i18n/firm-today.js
// Version: 1.0 (2026-10-16, Wave 1 Translation — Firm Today)
// Description: Словарь экрана «Сегодня» фирмы (FitenkoToday / firm today).
//              Соблюдает строгий паритет ключей EN/RU.

const EN = {
    // ── Приветствие и шапка ───────────────────────────────────────────────────
    'firm_today.greeting.morning': 'Good morning',
    'firm_today.greeting.afternoon': 'Good afternoon',
    'firm_today.greeting.evening': 'Good evening',
    'firm_today.header.pre': 'Today',
    'firm_today.header.open_inbox': 'Open inbox →',
    'firm_today.header.dash': '—',
    'firm_today.reason_not_specified': 'reason not specified',

    // ── Статус писем в подстроке ─────────────────────────────────────────────
    'firm_today.inbox.unknown': 'pending email count unknown',
    'firm_today.inbox.none': 'no emails awaiting decision',
    'firm_today.inbox.pending': '{count} emails awaiting decision',
    'firm_today.inbox.not_connected': 'mail not connected',

    // ── Карточка «Главное сейчас» ────────────────────────────────────────────
    'firm_today.priority.title': 'Current Priority',
    'firm_today.priority.all_cases': 'All cases ›',
    'firm_today.priority.caveat': 'Filtered strictly by DEADLINE: a deadline has either passed or not. No subjective ratings, percentages, scores, or scales are computed here.',
    'firm_today.priority.loading': 'Checking deadlines…',
    'firm_today.priority.denied': 'Access to deadlines denied: {reason}. This is a permission restriction, not an absence of deadlines.',
    'firm_today.priority.failed': 'Could not retrieve deadlines: {reason}. This does not mean there are no deadlines.',
    'firm_today.priority.days_left': '{count} days',
    'firm_today.priority.until': 'until {date}',
    'firm_today.priority.open_case': 'Open case ›',
    'firm_today.priority.reason': 'Deadline reason: {reason}',
    'firm_today.priority.none_upcoming': 'No upcoming deadline: no future deadline is set for any of the {visible} visible cases.',
    'firm_today.priority.not_none_urgent': 'This does not mean "nothing urgent". Until a deadline is set, there is nothing to select.',
    'firm_today.priority.stats': 'Cases without deadline: {without} of {visible} · marked "unknown for now": {unknown} · past deadlines: {past}',
    'firm_today.priority.named_stats': 'Named individually: {shown} of {total}',
    'firm_today.priority.set_deadline': 'Set deadline ›',

    // ── Блок «Встречи сегодня» ────────────────────────────────────────────────
    'firm_today.meetings.title': "Today's Appointments",
    'firm_today.meetings.all_calendar': 'Full calendar ›',
    'firm_today.meetings.caveat': 'Shows Google Calendar events. Appointments recorded inside a lead do not appear here.',
    'firm_today.meetings.not_connected': 'Calendar not connected — appointments unknown. This does not mean there are no appointments.',
    'firm_today.meetings.loading': 'Checking calendar…',
    'firm_today.meetings.denied': 'Access to calendar denied: {reason}.',
    'firm_today.meetings.failed': 'Calendar did not respond: {reason}. There may be any number of appointments.',
    'firm_today.meetings.empty': 'No appointments scheduled for today.',

    // ── Блок «Ждут вашего решения» ───────────────────────────────────────────
    'firm_today.inbox_block.title': 'Awaiting Your Decision',
    'firm_today.inbox_block.all_inbox': 'All mail ›',
    'firm_today.inbox_block.caveat': '"Approve & Send" sends a REAL email to the client — the button appears only below an expanded draft.',
    'firm_today.inbox_block.loading': 'Checking email…',
    'firm_today.inbox_block.denied': 'Access to email queue denied: {reason}. This is a permission restriction, not an empty queue.',
    'firm_today.inbox_block.failed': 'Could not retrieve email queue: {reason}. This does not mean zero.',
    'firm_today.inbox_block.empty': 'No emails awaiting decision.',
    'firm_today.inbox_block.not_connected': 'Mail not connected.',
    'firm_today.inbox_block.collapse_draft': 'Collapse draft',
    'firm_today.inbox_block.expand_draft': 'Show draft',
    'firm_today.inbox_block.approve_send': 'Approve & Send',
    'firm_today.inbox_block.dismiss': 'Dismiss',

    // ── Блок «Что происходит в фирме» ────────────────────────────────────────
    'firm_today.history.title': 'Firm Activity',
    'firm_today.history.all_history': 'Full history ›',
    'firm_today.history.caveat': 'Showing {shown} of {total} recent events; full feed on /history.{truncated}',
    'firm_today.history.truncated': ' Feed reached read limit — there are more events in database than returned.',
    'firm_today.history.loading': 'Checking firm feed…',
    'firm_today.history.denied': 'Access to feed denied: {reason}. This is a permission restriction, not an empty feed.',
    'firm_today.history.failed': 'Could not retrieve feed: {reason}. This does not mean zero.',
    'firm_today.history.empty': 'No events in feed.',
    'firm_today.history.inquiry_received': 'Inquiry received',
    'firm_today.history.call': 'Call',
    'firm_today.history.sms': 'SMS',
    'firm_today.history.email': 'Email',
    'firm_today.history.document_uploaded': 'Document uploaded',
    'firm_today.history.unnamed': 'No name',

    // ── Блок «Очередь задач» ──────────────────────────────────────────────────
    'firm_today.tasks.title': 'Task Queue',
    'firm_today.tasks.all_tasks': 'All tasks ›',
    'firm_today.tasks.caveat': 'Order is as returned by tasks endpoint; no custom order applied.',
    'firm_today.tasks.loading': 'Checking tasks…',
    'firm_today.tasks.denied': 'Access to tasks denied: {reason}.',
    'firm_today.tasks.failed': 'Could not retrieve tasks: {reason}. This does not mean zero.',
    'firm_today.tasks.empty': 'No open tasks assigned to you.',
    'firm_today.tasks.pill_all': 'All ({count})',
    'firm_today.tasks.pill_ai': 'From AI',
    'firm_today.tasks.pill_hot': 'Urgent',
    'firm_today.tasks.due': 'due {date}',
    'firm_today.tasks.ai_flag': 'AI',

    // ── Типы событий ленты ───────────────────────────────────────────────────
    'firm_today.event_type.lead_created': 'Lead created',
    'firm_today.event_type.call_received': 'Call received',
    'firm_today.event_type.sms_message': 'SMS message',
    'firm_today.event_type.email_received': 'Email received',
    'firm_today.event_type.document_uploaded': 'Document uploaded',
    'firm_today.event_type.case_created': 'Case created',
    'firm_today.event_type.task_created': 'Task created',
    'firm_today.event_type.task_completed': 'Task completed',
    'firm_today.event_type.team_assigned': 'Team assigned',
    'firm_today.event_type.question_asked': 'Question',
    'firm_today.event_type.decision_made': 'Decision',
    'firm_today.event_type.checklist_verified': 'Checklist verified',
};

const RU = {
    // ── Приветствие и шапка ───────────────────────────────────────────────────
    'firm_today.greeting.morning': 'Доброе утро',
    'firm_today.greeting.afternoon': 'Добрый день',
    'firm_today.greeting.evening': 'Добрый вечер',
    'firm_today.header.pre': 'Сегодня',
    'firm_today.header.open_inbox': 'Открыть почту →',
    'firm_today.header.dash': '—',
    'firm_today.reason_not_specified': 'причина не названа',

    // ── Статус писем в подстроке ─────────────────────────────────────────────
    'firm_today.inbox.unknown': 'сколько писем ждёт решения — не узнали',
    'firm_today.inbox.none': 'писем на решении нет',
    'firm_today.inbox.pending': 'писем ждёт решения: {count}',
    'firm_today.inbox.not_connected': 'почта не подключена',

    // ── Карточка «Главное сейчас» ────────────────────────────────────────────
    'firm_today.priority.title': 'Главное сейчас',
    'firm_today.priority.all_cases': 'Все дела ›',
    'firm_today.priority.caveat': 'Отбор — по СРОКУ и только по нему: срок либо наступил, либо нет. Ничего оценочного — ни доли, ни балла, ни шкалы — здесь не считается: за такими величинами не стоит вычисления.',
    'firm_today.priority.loading': 'Спрашиваю сроки…',
    'firm_today.priority.denied': 'Отказано в доступе к срокам: {reason}. Это отказ по правам, а не отсутствие сроков.',
    'firm_today.priority.failed': 'Сроки не получили: {reason}. Это не «сроков нет».',
    'firm_today.priority.days_left': '{count} дн.',
    'firm_today.priority.until': 'до {date}',
    'firm_today.priority.open_case': 'Открыть дело ›',
    'firm_today.priority.reason': 'Причина срока: {reason}',
    'firm_today.priority.none_upcoming': 'Ближайшего срока нет: срок в будущем не проставлен ни у одного из {visible} видимых дел.',
    'firm_today.priority.not_none_urgent': 'Это не «срочного нет». Пока срок не проставлен, отбирать нечего.',
    'firm_today.priority.stats': 'Дел без срока: {without} из {visible} · признано «пока неизвестен»: {unknown} · сроков в прошлом: {past}',
    'firm_today.priority.named_stats': 'Названы поимённо: {shown} из {total}',
    'firm_today.priority.set_deadline': 'Поставить срок ›',

    // ── Блок «Встречи сегодня» ────────────────────────────────────────────────
    'firm_today.meetings.title': 'Встречи сегодня',
    'firm_today.meetings.all_calendar': 'Весь календарь ›',
    'firm_today.meetings.caveat': 'Показаны события Google-календаря. Встречи, записанные в обращении, сюда не приходят.',
    'firm_today.meetings.not_connected': 'Календарь не подключён — встречи неизвестны. Это не «встреч нет».',
    'firm_today.meetings.loading': 'Спрашиваю календарь…',
    'firm_today.meetings.denied': 'Отказано в доступе к календарю: {reason}.',
    'firm_today.meetings.failed': 'Календарь не ответил: {reason}. Встреч может быть сколько угодно.',
    'firm_today.meetings.empty': 'На сегодня встреч нет.',

    // ── Блок «Ждут вашего решения» ───────────────────────────────────────────
    'firm_today.inbox_block.title': 'Ждут вашего решения',
    'firm_today.inbox_block.all_inbox': 'Вся почта ›',
    'firm_today.inbox_block.caveat': '«Одобрить и отправить» шлёт клиенту НАСТОЯЩЕЕ письмо — кнопка появляется только под раскрытым черновиком.',
    'firm_today.inbox_block.loading': 'Спрашиваю почту…',
    'firm_today.inbox_block.denied': 'Отказано в доступе к очереди писем: {reason}. Это отказ по правам, а не пустая очередь.',
    'firm_today.inbox_block.failed': 'Очередь писем не получили: {reason}. Это не ноль.',
    'firm_today.inbox_block.empty': 'Писем на решении нет.',
    'firm_today.inbox_block.not_connected': 'Почта не подключена.',
    'firm_today.inbox_block.collapse_draft': 'Свернуть черновик',
    'firm_today.inbox_block.expand_draft': 'Показать черновик',
    'firm_today.inbox_block.approve_send': 'Одобрить и отправить',
    'firm_today.inbox_block.dismiss': 'Отклонить',

    // ── Блок «Что происходит в фирме» ────────────────────────────────────────
    'firm_today.history.title': 'Что происходит в фирме',
    'firm_today.history.all_history': 'Вся история ›',
    'firm_today.history.caveat': 'Показаны {shown} из {total} последних событий; вся лента — на /history.{truncated}',
    'firm_today.history.truncated': ' Лента упёрлась в предел чтения — событий в базе больше, чем отдала ручка.',
    'firm_today.history.loading': 'Спрашиваю ленту фирмы…',
    'firm_today.history.denied': 'Отказано в доступе к ленте: {reason}. Это отказ по правам, а не пустая лента.',
    'firm_today.history.failed': 'Ленту не получили: {reason}. Это не ноль.',
    'firm_today.history.empty': 'Ни одного события в ленте.',
    'firm_today.history.inquiry_received': 'Обращение принято',
    'firm_today.history.call': 'Звонок',
    'firm_today.history.sms': 'СМС',
    'firm_today.history.email': 'Письмо',
    'firm_today.history.document_uploaded': 'Загружен документ',
    'firm_today.history.unnamed': 'Без имени',

    // ── Блок «Очередь задач» ──────────────────────────────────────────────────
    'firm_today.tasks.title': 'Очередь задач',
    'firm_today.tasks.all_tasks': 'Все задачи ›',
    'firm_today.tasks.caveat': 'Порядок — тот, каким отдала ручка задач; своего порядка у неё нет.',
    'firm_today.tasks.loading': 'Спрашиваю задачи…',
    'firm_today.tasks.denied': 'Отказано в доступе к задачам: {reason}.',
    'firm_today.tasks.failed': 'Задачи не получили: {reason}. Это не ноль.',
    'firm_today.tasks.empty': 'Открытых задач за вами нет.',
    'firm_today.tasks.pill_all': 'Все ({count})',
    'firm_today.tasks.pill_ai': 'От ИИ',
    'firm_today.tasks.pill_hot': 'Срочные',
    'firm_today.tasks.due': 'до {date}',
    'firm_today.tasks.ai_flag': 'ИИ',

    // ── Типы событий ленты ───────────────────────────────────────────────────
    'firm_today.event_type.lead_created': 'Обращение',
    'firm_today.event_type.call_received': 'Звонок',
    'firm_today.event_type.sms_message': 'СМС',
    'firm_today.event_type.email_received': 'Письмо',
    'firm_today.event_type.document_uploaded': 'Документ',
    'firm_today.event_type.case_created': 'Дело заведено',
    'firm_today.event_type.task_created': 'Задача',
    'firm_today.event_type.task_completed': 'Задача закрыта',
    'firm_today.event_type.team_assigned': 'Назначение',
    'firm_today.event_type.question_asked': 'Вопрос',
    'firm_today.event_type.decision_made': 'Решение',
    'firm_today.event_type.checklist_verified': 'Сверка',
};

export const SLOVAR = Object.freeze({
    en: Object.freeze(EN),
    ru: Object.freeze(RU),
});

export function perevesti(lang, key, vars) {
    const yazyk = lang === 'ru' ? 'ru' : 'en';
    const slovar = SLOVAR[yazyk];
    if (!slovar || !Object.prototype.hasOwnProperty.call(slovar, key)) {
        return `[${key}]`;
    }
    const shablon = slovar[key];
    const peremennye = vars && typeof vars === 'object' ? vars : {};
    return shablon.replace(/\{([a-zA-Z_]+)\}/g, (celoe, imya) => (
        Object.prototype.hasOwnProperty.call(peremennye, imya) &&
        peremennye[imya] !== undefined &&
        peremennye[imya] !== null
            ? String(peremennye[imya])
            : '—'
    ));
}

export function raznitsaKlyuchey(a, b) {
    const vB = b || {};
    return Object.keys(a || {})
        .filter((k) => !Object.prototype.hasOwnProperty.call(vB, k))
        .sort();
}
